// src/context/AppContext.js

import React, { createContext, useState, useContext } from 'react';

const AppContext = createContext(null);

export const AppProvider = ({ children }) => {
    const [isTimerOpen, setIsTimerOpen] = useState(false);

    const openTimer = () => setIsTimerOpen(true);
    const closeTimer = () => setIsTimerOpen(false);

    const value = {
        isTimerOpen,
        openTimer,
        closeTimer
    };

    return <AppContext.Provider value={value}>{children}</AppContext.Provider>;
};

export const useAppContext = () => {
    const context = useContext(AppContext);
    
    if (context === null) {
        throw new Error("useAppContext must be used within an AppProvider");
    }
 
    return context;
};